import { render, staticRenderFns } from "./ItemVersion.vue?vue&type=template&id=729c72d6"
import script from "./ItemVersion.vue?vue&type=script&lang=js"
export * from "./ItemVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports